import validate_role from "@/router/module/validate_role";
import get_title from "@/router/module/get_title";

export default {
  path: "/content/categories",
  component: () => import("@/views/Content/Categories"),
  meta: {
    title: get_title("Категории"),
    forVisitors: true,
    requiresAuth: true
  },
  beforeEnter: (to, from, next) => {
    const options = {
      role: "categories.show-list",
      route: { to, from, next },
      callback: false,
      redirectText: "У вас нет доступа к разделу с категориями!",
    };
    validate_role(options);
  },
};
